export default "__VITE_ASSET__BrmexsNq__"